import React from "react";
import { Popconfirm } from "antd";

const columns = ({ sorted, fromChild, onDelete, onEdit }) => {
  const onClickImage = (image) => fromChild(image);

  return [
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className="action-btn" style={{ width: "80px" }}>
          <a
            title="Edit"
            className="pencilIcon"
            onClick={(e) => {
              e.preventDefault();
              onEdit(record);
            }}
          >
            <i className="fa fa-pencil"></i>
          </a>
          <a href="" title="Delete">
            <Popconfirm
              title="Are you sure you want to delete this ad?"
              onConfirm={() => onDelete(record.key)}
              okText="Yes"
              cancelText="No"
            >
              <span className="gx-link" title="Delete">
                <i className="icon icon-trash"></i>
              </span>
            </Popconfirm>
          </a>
        </div>
      )
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      sortOrder: sorted.columnKey === "name" && sorted.order
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      sorter: (a, b) => a.url.localeCompare(b.url),
      sortOrder: sorted.columnKey === "url" && sorted.order
    },
    {
      title: "Impressions",
      dataIndex: "impressionCount",
      key: "impressionCount",
      sorter: (a, b) => a.impressionCount - b.impressionCount,
      sortOrder: sorted.columnKey === "impressionCount" && sorted.order
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span style={{ color: text === "Active" ? "green" : "red" }}>{text}</span>
      )
    },
    {
      title: "Last Updated On",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => a.date.localeCompare(b.date),
      sortOrder: sorted.columnKey === "date" && sorted.order
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (text, record) => (
        <img
          src={record.image}
          alt={record.name}
          style={{ maxWidth: "200px", maxHeight: "120px", cursor: "pointer" }}
          onClick={() => onClickImage(record.image)}
        />
      )
    }
  ];
};

export default columns;
